import { Icon } from '@chakra-ui/react';

export const EmailIcon = (props: any) => (
  <Icon aria-label="email icon" viewBox="0 0 18 18" {...props}>
    <path
      d="M15,3 C15.8284271,3 16.5,3.67157288 16.5,4.5 L16.5,13.5 C16.5,14.3284271 15.8284271,15 15,15 L3,15 C2.17157288,15 1.5,14.3284271 1.5,13.5 L1.5,4.5 C1.5,3.67157288 2.17157288,3 3,3 L15,3 Z M9,9.75 C8.30925623,9.75 6.52091191,8.60261915 3.00076552,5.99535975 L3,13.5 L15,13.5 L15.0002219,5.99462836 C11.4794225,8.60240458 9.69080836,9.75 9,9.75 Z M14.4950803,4.50042965 L3.5049197,4.50042965 C6.72361742,6.88801531 8.78286993,8.25 9,8.25 C9.21713007,8.25 11.2763826,6.88801531 14.4950803,4.50042965 Z"
      fill="currentColor"
    />
  </Icon>
);
